import { apiV2Root } from "consts";
import bem from "easy-bem";
import type { UserRatingScores } from "features/activity-log/data/types";
import { useDataQueryParams } from "hooks/useDataQueryParams";
import React from "react";

import "./RatingCells.css";

const cn = bem("rating-cells");

type RatingCellsProps = {
  personId: number;
};

const RatingCells: React.FC<RatingCellsProps> = ({ personId }) => {
  const rating = useDataQueryParams<UserRatingScores>(
    "activity-log/rating",
    { person_id: personId },
    apiV2Root,
  );

  if (!rating) {
    return null;
  }

  const {
    engagementScore: engagement,
    authorityScore: authority,
    learningScore: learning,
  } = rating;
  // Черновая формула — L пока не применяется как множитель
  const overall = engagement + authority;

  return (
    <div className={cn()}>
      <div className={cn("grid")}>
        <div className={cn("cell")}>
          <div className={cn("cell-value")}>{engagement}</div>
          <div className={cn("cell-label")}>E — вовлечённость</div>
        </div>
        <div className={cn("cell")}>
          <div className={cn("cell-value")}>{authority}</div>
          <div className={cn("cell-label")}>A — авторитет</div>
        </div>
        <div className={cn("cell")}>
          <div className={cn("cell-value")}>{learning}</div>
          <div className={cn("cell-label")}>L — качество вклада</div>
        </div>
        <div className={cn("cell", { highlight: true })}>
          <div className={cn("cell-value")}>{overall}</div>
          <div className={cn("cell-label")}>Рейтинг (черновой, A+E)</div>
        </div>
      </div>
    </div>
  );
};

export default RatingCells;
